import * as React from 'react';
import { AppContext, IAppContext } from './Types/Intyg.types';
import AktuellLegitimation from './Forms/AktuellLegitimation';
import { FormType } from './Types/Intyg.enums';
import { IntygsAnsokan, UppdateraIntygsArende, LeveransAdress, UppdateraLeveransAdress } from './Types/ansokan.types';
import Kontaktlinsbehorighet from './Forms/Kontaktlinsbehorighet';
import { ApiService } from './Services/intyg.api.service';
import { LegitimationInomEU } from './Forms/LegitimationInomEU';
import _ from 'lodash';
import { Artikel3_3 } from './Forms/Artikel3_3';
import Forskrivningsratt from './Forms/Forskrivningsratt';
import AT_Tjanstgoring from './Forms/AT_Tjanstgoring';

export interface IEserviceWrapperProps {}

export interface IEserviceWrapperState {}

export class EserviceWrapper extends React.Component<IEserviceWrapperProps, IEserviceWrapperState> {
  static contextType = AppContext;
  //@ts-expect-error
  public context: IAppContext = this.context;
  private model: IntygsAnsokan;
  private adresser: LeveransAdress[];

  constructor(props: IEserviceWrapperProps, context: IAppContext) {
    super(props);
    context.onClickSubmitButton = this.navigateToStepTwo;
    this.state = {};
  }

  navigateToStepTwo = () => {
    window.location.href = `${this.context.stepTwoPageLink}?ansokanId=${this.context.ansokanId}`;
  };

  componentDidMount = () => {
    this.model = this.context.model;
    this.adresser = _.cloneDeep(this.context.model.adresser);
  };

  componentDidUpdate = () => {
    const { ansokanId, isInEditMode } = this.context;

    if (this.model !== this.context.model) {
      if (!isInEditMode) {
        console.log('Calling SAVE');
        const mapped = this.mapContextToUpdateModel(this.context.model);

        ApiService.call.saveAnsokan(mapped, ansokanId).then((response) => {
          console.log(response);
        });

        // Detecting changes to adresser-objects
        if (this.adresser !== null) {
          this.context.model.adresser?.forEach((adress, i) => {
            if (!_.isEqual(adress, this.adresser[i])) {
              ApiService.call
                .updateAddress(this.mapContextToAdressUpdateModel(adress), ansokanId, adress.id)
                .then((response) => {
                  console.log(response);
                });
            }
          });
        }
        this.adresser = _.cloneDeep(this.context.model.adresser);
        this.model = this.context.model;
      }
    }
  };

  mapContextToAdressUpdateModel(adress: LeveransAdress): UppdateraLeveransAdress {
    const uppdateraLeveransAdress = _.cloneDeep(adress);
    delete uppdateraLeveransAdress.id;
    return uppdateraLeveransAdress;
  }

  mapContextToUpdateModel(model: IntygsAnsokan): UppdateraIntygsArende {
    const updateModel: UppdateraIntygsArende = {
      antalEngelskaTillFolkbokforing: model.antalEngelskaTillFolkbokforing ?? 0,
      antalSvenskaTillFolkbokforing: model.antalSvenskaTillFolkbokforing ?? 0,
      epost: model.epost,
      pdfEngelska: model.pdfEngelska ?? false,
      pdfSvenska: model.pdfSvenska ?? false,
      skickaPdf: model.skickaPdf ?? false,
      skickaPost: model.skickaPost ?? false,
      skickaTillFolkbokforing: model.skickaTillFolkbokforing,
      yrkeId: model.yrkeId,
    };

    if (!updateModel.skickaPost) {
      updateModel.skickaTillFolkbokforing = false;
    }

    if (updateModel.skickaTillFolkbokforing) {
      updateModel.skickaPost = true;
    }

    return updateModel;
  }

  renderForm = () => {
    switch (this.context.formType) {
      case FormType.Intyg_for_aktuell_legitimation:
        return <AktuellLegitimation />;
      case FormType.Intyg_om_kontaktlinsbehorighet:
        return <Kontaktlinsbehorighet />;
      case FormType.Intyg_for_legitimation_inom_EU:
        return <LegitimationInomEU />;
      case FormType.Artikel_33:
        // eslint-disable-next-line react/jsx-pascal-case
        return <Artikel3_3 />;
      case FormType.Intyg_om_AT_tjanstgoring:
        // eslint-disable-next-line react/jsx-pascal-case
        return <AT_Tjanstgoring />;
      case FormType.Intyg_om_forskrivningsratt:
        return <Forskrivningsratt />;
      default:
        return <div>Det angivna formuläret har ingen känd formulärtyp.</div>;
    }
  };

  public render() {
    return this.renderForm();
  }
}
